/* eslint-disable no-unused-expressions */
/* eslint-disable consistent-return */
/* eslint-disable no-underscore-dangle */
/* eslint-disable indent */
/* eslint-disable no-tabs */
import { useContext } from 'react';
import { Context as AlertContext } from 'contexts/alert';
import { Context as AuthContext } from 'contexts/auth';
import { Config } from 'configs';
import { code, db, iam } from 'codemash';
import { getErrorMessage, manageFunctionResponse } from 'utils/errorHandler';

import { resourceRequest } from 'api/client/requests';
import { apiActionChooser } from 'utils/apiActionChooser';
import createDataContext from './createDataContext';

const reducer = (state, action) => {
  switch (action.type) {
    case 'onContextInitialized':
      return {
        ...state,
        initialized: true,
        alertController: action.payload.alertController,
      };
    case 'set_loading':
      return { ...state, isLoading: action.payload };
    case 'set_loading_restaurants':
      return { ...state, isLoadingRestaurants: action.payload };
    case 'set_restaurants':
      return { ...state, restaurants: action.payload || [], restaurantsGot: true };
    case 'addGroup':
      return {
        isLoading: state.isLoading,
        errorMessage: null,
        token: action.payload.token,
        user: action.payload.user,
        isSigned: true,
        initialized: true,
        authChecked: true,
      };
    case 'set_error':
      return { ...state, errorMessage: action.payload };
    case 'clear_error':
      return { ...state, errorMessage: null };
    case 'clear_on_logout':
      return { ...state, restaurants: [], isLoadingRestaurants: false, restaurantsGot: false };
    default:
      return state;
  }
};

const init = (dispatch) => () => {
  const { alertController } = useContext(AlertContext);
  const { state: auth } = useContext(AuthContext);

  dispatch({
    type: 'onContextInitialized',
    payload: { alertController, companyId: auth.company?.company },
  });
};

const getCompanyRestaurants =
  (dispatch, state) =>
  async ({ token, companyId, refresh }) => {
    if (!refresh && (state.restaurantsGot || state.isLoadingRestaurants)) {
      return state.restaurants || [];
    }

    try {
      dispatch({ type: 'set_loading_restaurants', payload: true });

      let response;

      await apiActionChooser(companyId, async () => {
        response = await db.getRecords({
          secretKey: token,
          database: Config.CODEMASH.DATABASE_ID,
          collectionName: Config.DATA.COLLECTIONS.RESTAURANTS,
          filter: `{ company: ObjectId('${companyId}') }`,
        });
      }, async () => {
        response = await resourceRequest({
          data: { resource: 'AdminRestaurant' },
          action: 'find',
        });
      });

      dispatch({ type: 'set_restaurants', payload: response?.result || [] });

      return response?.result || [];
    } catch (e) {
      Config.SHOW_LOGS && console.log('Failed to get restaurants', e);
    } finally {
      dispatch({ type: 'set_loading_restaurants', payload: false });
    }

    return [];
  };

const shouldDisplayNoRestaurantBlock = (_, state) => () => {
  return state.restaurants && state.restaurants.length === 0 && !state.isLoadingRestaurants;
};

const getByFilter =
  (dispatch, state) =>
  async ({ collectionName, filter, token }) => {
    try {
      dispatch({ type: 'set_loading', payload: true });

      const response = await db.getRecords({
        secretKey: token,
        database: Config.CODEMASH.DATABASE_ID,
        collectionName,
        filter,
        // language: 'lt', // Config.DEFAULTS.LANGUAGE,
      });

      return response;
    } catch (e) {
      Config.SHOW_LOGS && console.log('Error occured', e);

      if (state?.alertController) {
        state.alertController.error(getErrorMessage(e));
      }

      dispatch({
        type: 'set_error',
        payload: e,
      });
    } finally {
      dispatch({ type: 'set_loading', payload: false });
    }

    return null;
  };

const getOneByFilter =
  (dispatch, state) =>
  async ({
 collectionName, filter, token,
    includeCollectionNames,
    includeUserNames,
    includeRoleNames,
    includeTermNames,
    referencedFields,
    excludeCulture,
    ignoreError,
    resourceV2,
    companyIdForV2,
}) => {
    try {
      dispatch({ type: 'set_loading', payload: true });

      let response;

      await apiActionChooser(companyIdForV2, async () => {
        response = await db.getRecordWithFilter({
          secretKey: token,
          database: Config.CODEMASH.DATABASE_ID,
          collectionName,
          filter,
          includeCollectionNames: includeCollectionNames || false,
          includeUserNames: includeUserNames || false,
          includeRoleNames: includeRoleNames || false,
          includeTermNames: includeTermNames || false,
          // projection,
          referencedFields,
          excludeCulture: excludeCulture || false,
          // language: 'lt', // Config.DEFAULTS.LANGUAGE,
        });
      }, async () => {
        let parsedFilter = filter;

        if (parsedFilter && typeof parsedFilter !== 'string') {
          parsedFilter = JSON.stringify(parsedFilter);
        }

        response = await resourceRequest({
          data: {
            resource: resourceV2,
            filter: parsedFilter,
            referencedFields,
          },
          action: 'findOne',
        });
      });

      return response;
    } catch (e) {
      Config.SHOW_LOGS && console.log('Error occured', e);

      if (state?.alertController && !ignoreError) {
        state.alertController.error(getErrorMessage(e));
      }

      dispatch({
        type: 'set_error',
        payload: e,
      });
    } finally {
      dispatch({ type: 'set_loading', payload: false });
    }

    return null;
  };

const getById =
  (dispatch, state) =>
  async ({
    collectionName,
    id,
    token,
    includeCollectionNames,
    includeUserNames,
    includeRoleNames,
    includeTermNames,
    projection,
    referencedFields,
    excludeCulture,
    resourceV2,
    companyIdForV2,
  }) => {
    try {
      dispatch({ type: 'set_loading', payload: true });

      let response;

      await apiActionChooser(companyIdForV2, async () => {
        response = await db.getRecord({
          secretKey: token,
          database: Config.CODEMASH.DATABASE_ID,
          collectionName,
          id,
          includeCollectionNames: includeCollectionNames || false,
          includeUserNames: includeUserNames || false,
          includeRoleNames: includeRoleNames || false,
          includeTermNames: includeTermNames || false,
          // projection,
          projection,
          referencedFields,
          excludeCulture: excludeCulture || false,
          // language: 'lt', // Config.DEFAULTS.LANGUAGE,
        });
      }, async () => {
        let parsedProjection = projection;

        if (parsedProjection && typeof parsedProjection !== 'string') {
          parsedProjection = JSON.stringify(parsedProjection);
        }

        response = await resourceRequest({
          data: {
            resource: resourceV2,
            id,
            projection: parsedProjection,
            referencedFields,
          },
          action: 'findOne',
        });
      });

      return response;
    } catch (e) {
      Config.SHOW_LOGS && console.log('Error occured', e);

      if (state?.alertController) {
        state.alertController.error(getErrorMessage(e));
      }

      dispatch({
        type: 'set_error',
        payload: e,
      });
    } finally {
      dispatch({ type: 'set_loading', payload: false });
    }

    return null;
  };

const getUserById =
  (dispatch, state) =>
  async ({ id, token }) => {
    try {
      dispatch({ type: 'set_loading', payload: true });

      const response = await iam.getUser({
        secretKey: token,
        id,
      });

      return response;
    } catch (e) {
      Config.SHOW_LOGS && console.log('Error occured', e);

      if (state?.alertController) {
        state.alertController.error(getErrorMessage(e));
      }

      dispatch({
        type: 'set_error',
        payload: e,
      });
    } finally {
      dispatch({ type: 'set_loading', payload: false });
    }

    return null;
  };

const addNew =
  (dispatch, state) =>
  async ({ collectionName, token, data, responsibleUserId, resourceV2, companyIdForV2 }, callback, errorCallback) => {
    try {
      dispatch({ type: 'set_loading', payload: true });

      let response;

      await apiActionChooser(companyIdForV2, async () => {
        response = await db.insertRecord({
          collectionName,
          database: Config.CODEMASH.DATABASE_ID,
          document: data,
          secretKey: token,
          responsibleUserId,
        });
      }, async () => {
        response = await resourceRequest({
          data: {
            resource: resourceV2,
            document: JSON.stringify(data),
          },
          action: 'insertOne',
        });
      });

      if (response) {
        dispatch({ type: 'set_loading', payload: false });

        if (callback) {
          await callback(response._id, response);
        }
      }
    } catch (e) {
      Config.SHOW_LOGS && console.log('Error occured', e);

      if (state?.alertController) {
        state.alertController.error(getErrorMessage(e));
      }

      dispatch({
        type: 'set_error',
        payload: e,
      });

      if (errorCallback) {
        errorCallback(e);
      }
    } finally {
      dispatch({ type: 'set_loading', payload: false });
    }
  };

const assignGroupToClient =
  (dispatch, state) =>
  async ({ token, company, client, groups }, callback) => {
    try {
      dispatch({ type: 'set_loading', payload: true });

      const findClientGroups = await db.getRecordWithFilter({
        collectionName: Config.DATA.COLLECTIONS.COMPANY_CLIENT_GROUPS,
        database: Config.CODEMASH.DATABASE_ID,
        secretKey: token,
        filter: `{ company: ObjectId('${company}'), client: ObjectId('${client}') }`,
      });

      if (findClientGroups) {
        const response = await db.updateRecordWithFilter({
          collectionName: Config.DATA.COLLECTIONS.COMPANY_CLIENT_GROUPS,
          database: Config.CODEMASH.DATABASE_ID,
          secretKey: token,
          filter: `{ company: ObjectId('${company}'), client: ObjectId('${client}') }`,
          update: {
            // eslint-disable-next-line object-curly-newline
            $push: {
              groups },
          },
        });

        if (response) {
          dispatch({ type: 'set_loading', payload: false });

          if (callback) {
            await callback(response._id);
          }
        }
      } else {
        const response = await db.insertRecord({
          collectionName: Config.DATA.COLLECTIONS.COMPANY_CLIENT_GROUPS,
          database: Config.CODEMASH.DATABASE_ID,
          document: {
            company,
            client,
            groups: [groups],
          },
          secretKey: token,
        });

        if (response) {
          dispatch({ type: 'set_loading', payload: false });

          if (callback) {
            await callback(response._id);
          }
        }
      }
    } catch (e) {
      Config.SHOW_LOGS && console.log('Error occured', e);

      if (state?.alertController) {
        state.alertController.error(getErrorMessage(e));
      }

      dispatch({
        type: 'set_error',
        payload: e,
      });
    } finally {
      dispatch({ type: 'set_loading', payload: false });
    }
  };

const deleteGroupFromClient =
  (dispatch, state) =>
  async ({ token, company, client, groups }, callback) => {
    try {
      dispatch({ type: 'set_loading', payload: true });

      const response = await db.updateRecordWithFilter({
        collectionName: Config.DATA.COLLECTIONS.COMPANY_CLIENT_GROUPS,
        database: Config.CODEMASH.DATABASE_ID,
        secretKey: token,
        filter: `{ company: ObjectId('${company}'), client: ObjectId('${client}') }`,
        update: `{
          $pull: { groups: { $eq: ObjectId('${groups}') } },
        }`,
      });

      if (response) {
        dispatch({ type: 'set_loading', payload: false });

        if (callback) {
          await callback(response._id);
        }
      }
    } catch (e) {
      Config.SHOW_LOGS && console.log('Error occured', e);

      if (state?.alertController) {
        state.alertController.error(getErrorMessage(e));
      }

      dispatch({
        type: 'set_error',
        payload: e,
      });
    } finally {
      dispatch({ type: 'set_loading', payload: false });
    }
  };

const editById =
  (dispatch, state) =>
  async ({ collectionName, id, updateClause, token, ignoreTriggers, resourceV2, updateTypeV2, updateDataV2, companyIdForV2 }, callback, errorCallback) => {
    try {
      dispatch({ type: 'set_loading', payload: true });

      let response;

      await apiActionChooser(companyIdForV2, async () => {
        response = await db.updateRecord({
          collectionName,
          database: Config.CODEMASH.DATABASE_ID,
          id,
          update: updateClause,
          secretKey: token,
          ignoreTriggers,
        });
      }, async () => {
        response = await resourceRequest({
          data: {
            resource: resourceV2,
            id,
            updateType: updateTypeV2,
            data: updateDataV2,
          },
          action: 'updateOne',
        });
      });

      if (response) {
        dispatch({ type: 'set_loading', payload: false });

        if (callback) {
          await callback();
        }
      }
    } catch (e) {
      Config.SHOW_LOGS && console.log('Error occured', e);

      if (state?.alertController) {
        state.alertController.error(getErrorMessage(e));
      }

      dispatch({
        type: 'set_error',
        payload: e,
      });

      if (errorCallback) {
        errorCallback(e);
      }
    } finally {
      dispatch({ type: 'set_loading', payload: false });
    }
  };

  const replaceById =
  (dispatch, state) =>
  async ({ collectionName, token, id, data, isUpsert, companyIdForV2, resourceV2 }, callback, errorCallback) => {
    try {
      dispatch({ type: 'set_loading', payload: true });

      let response;

      await apiActionChooser(companyIdForV2, async () => {
        response = await db.replaceRecord({
          collectionName,
          database: Config.CODEMASH.DATABASE_ID,
          id,
          document: data,
          secretKey: token,
          isUpsert,
        });
      }, async () => {
        response = await resourceRequest({
          data: {
            resource: resourceV2,
            id,
            document: JSON.stringify(data),
            isUpsert,
          },
          action: 'replaceOne',
        });
      });

      if (response) {
        dispatch({ type: 'set_loading', payload: false });

        if (callback) {
          await callback(response._id);
        }
      }
    } catch (e) {
      Config.SHOW_LOGS && console.log('Error occured', e);

      if (state?.alertController) {
        state.alertController.error(getErrorMessage(e));
      }

      dispatch({
        type: 'set_error',
        payload: e,
      });

      if (errorCallback) {
        errorCallback(e);
      }
    } finally {
      dispatch({ type: 'set_loading', payload: false });
    }
  };

const deleteById =
  (dispatch, state) =>
  async ({ collectionName, token, id, companyIdForV2, resourceV2 }, callback) => {
    try {
      dispatch({ type: 'set_loading', payload: true });

      let response;

      await apiActionChooser(companyIdForV2, async () => {
        response = await db.deleteRecord({
          collectionName,
          database: Config.CODEMASH.DATABASE_ID,
          id,
          secretKey: token,
        });
      }, async () => {
        response = await resourceRequest({
          data: {
            resource: resourceV2,
            id,
          },
          action: 'deleteOne',
        });
      });

      if (response) {
        if (callback) {
          callback();
        }
      }
    } catch (e) {
      Config.SHOW_LOGS && console.log('Error occured', e);

      if (state?.alertController) {
        state.alertController.error(getErrorMessage(e));
      }

      dispatch({
        type: 'set_error',
        payload: e,
      });
    } finally {
      dispatch({ type: 'set_loading', payload: false });
    }
  };

const deleteUserById =
  (dispatch, state) =>
  async ({ token, id }) => {
    try {
      dispatch({ type: 'set_loading', payload: true });

      const response = await iam.deleteUser({
        secretKey: token,
        id,
      });

      return response;
    } catch (e) {
      Config.SHOW_LOGS && console.log('Error occured', e);

      if (state?.alertController) {
        state.alertController.error(getErrorMessage(e));
      }

      dispatch({
        type: 'set_error',
        payload: e,
      });
    } finally {
      dispatch({ type: 'set_loading', payload: false });
    }
  };

const createNewUser =
  (dispatch, state) =>
  async ({ firstName, lastName, userName, password, roles, token }, callback) => {
    try {
      dispatch({ type: 'set_loading', payload: true });

      const response = await iam.register({
        secretKey: token,
        userName,
        password,
        firstName,
        lastName,
        displayName: `${firstName} ${lastName}`,
        roles,
      });

      if (response && response.result && callback) {
        console.log('user has been created', response);
        callback(response.result.id);
      }

      return response;
    } catch (e) {
      Config.SHOW_LOGS && console.log('Error occured', e);

      if (state?.alertController) {
        state.alertController.error(getErrorMessage(e));
      }

      dispatch({
        type: 'set_error',
        payload: e,
      });
    } finally {
      dispatch({ type: 'set_loading', payload: false });
    }

    return null;
  };

const assignRolesToEmployee =
  (dispatch, state) =>
  async ({ token, id, roles }, callback) => {
    try {
      dispatch({ type: 'set_loading', payload: true });
      const response = await iam.updateUser({
        id,
        secretKey: token,
        roles,
      });

      if (response) {
        if (callback) {
          callback();
        }
      }
    } catch (e) {
      Config.SHOW_LOGS && console.log('Error occured', e);

      if (state?.alertController) {
        state.alertController.error(getErrorMessage(e));
      }

      dispatch({
        type: 'set_error',
        payload: e,
      });
    } finally {
      dispatch({ type: 'set_loading', payload: false });
    }
  };

const resetEmployeePassword =
  (dispatch, state) =>
  async ({ token, id }) => {
    try {
      dispatch({ type: 'set_loading', payload: true });
      /*
      const newPassword =
        Math.random().toString(12).substring(2, 6) + Math.random().toString(12).substring(2, 6);

      const response = await iam.updatePassword({
        secretKey: token,
        userId: id,
        password: newPassword,
      }); */

      const response = await code.executeFunction({
        secretKey: token,
        functionId: '8426448b-f426-4437-bf2f-8572289c93d7',
        data: {
          id,
          token,
        },
      });

      const managedResponse = manageFunctionResponse({
        response,
        alertController: state?.alertController,
      });

      if (managedResponse.isError) {
        if (!managedResponse.handled) {
          if (state?.alertController) {
            state.alertController.error({ text: managedResponse.message });
          }
        }
      } else {
        return managedResponse.newPassword;
      }

      return null;
    } catch (e) {
      Config.SHOW_LOGS && console.log('Error occured', e);

      if (state?.alertController) {
        state.alertController.error(getErrorMessage(e));
      }

      dispatch({
        type: 'set_error',
        payload: e,
      });
    } finally {
      dispatch({ type: 'set_loading', payload: false });
    }
  };

const getCountOfRecords =
  (dispatch, state) =>
  async ({ collectionName, filter, token }) => {
    try {
      dispatch({ type: 'set_loading', payload: true });
      const response = await db.count({
        database: Config.CODEMASH.DATABASE_ID,
        collectionName,
        filter,
        secretKey: token,
      });

      return response;
    } catch (e) {
      Config.SHOW_LOGS && console.log('Error occured', e);

      if (state?.alertController) {
        state.alertController.error(getErrorMessage(e));
      }

      dispatch({
        type: 'set_error',
        payload: e,
      });
    } finally {
      dispatch({ type: 'set_loading', payload: false });
    }
  };

const findClientByEmailOrPhone =
  (dispatch, state) =>
  async ({ query, selectedClients, token }) => {
    try {
      let email = query;
      const phone = query;

      if (query && query.indexOf('+') > -1) {
        email = email.replace('+', '');
      }

      dispatch({ type: 'set_loading', payload: true });
      const response = await db.getRecordWithFilter({
        collectionName: Config.DATA.COLLECTIONS.CLIENTS,
        database: Config.CODEMASH.DATABASE_ID,
        filter: `{ $or: [{email: /^${email}$/i}, {phone: "${phone}"}], user: { $nin: [${selectedClients
          ?.map((cp) => `"${cp.user}"`)
          .join(',')}] } }`,
        secretKey: token,
      });

      return response;
    } catch (e) {
      Config.SHOW_LOGS && console.log('Error occured', e);

      if (state?.alertController) {
        state.alertController.error(getErrorMessage(e));
      }

      dispatch({
        type: 'set_error',
        payload: e,
      });
    } finally {
      dispatch({ type: 'set_loading', payload: false });
    }
  };

const clearOnLogout = (dispatch) => () => {
  dispatch({ type: 'clear_on_logout' });
};

const initialData = { initialized: false, restaurants: [], alertController: null };

export const { Context, Provider } = createDataContext(
  reducer,
  {
    getById,
    getOneByFilter,
    getByFilter,
    addNew,
    editById,
    replaceById,
    deleteById,
    getCountOfRecords,
    getCompanyRestaurants,
    shouldDisplayNoRestaurantBlock,
    createNewUser,
    deleteUserById,
    getUserById,
    assignRolesToEmployee,
    resetEmployeePassword,
    assignGroupToClient,
    deleteGroupFromClient,
    findClientByEmailOrPhone,
    clearOnLogout,
  },
  { ...initialData },
  null,
  init,
);
